import React from 'react';

const InUseStatus = () => <div>In-use&nbsp;<img src='/images/status-in-use.svg'/></div>;
const AvailableStatus = () => <div>Available&nbsp;<img src='/images/status-active.svg'/></div>;
const UnavailableStatus = () => <span style={{ color: 'orange' }}>Unavailable</span>;

export { InUseStatus, AvailableStatus, UnavailableStatus };
